import { Stack } from '@mui/material';

import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import {
  PrimaryButton,
  PrimaryOutlinedButton,
} from '../../../../components/style/ButtonStyle';
import {
  InspectionTitle,
  ListSubContentText,
} from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { InspectionScoreList } from '../../../../utils/enum';
import { fDate } from '../../../../utils/formatTime';
import { InspectionInputs } from './InspectionInputs';
import { sliceSerialNumber } from '../../../../utils/helper';

export function AddInspectionCard({
  facility,
  setMode,
  getInspections,
  getFacilities,
  getFacility,
}: any) {
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      inspectionResult: Yup.array().nullable(),
      inspectionDate: Yup.string().required('필수 입력값입니다.'),
      inspectionNote: Yup.string().max(1000, '최대 1000자입니다.').nullable(),
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      inspectionScore: InspectionScoreList.A,
      inspectionDate: new Date(),
      inspectionNote: '',
      inspectionResult: [],
    },
    shouldUnregister: false,
  });

  const [postInspectionResult, postInspection] = useAuthAxios(
    {
      method: 'POST',
      url: '/api/v1/inspection',
    },
    { manual: true },
  );

  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      facilityId: facility.facilityId,
      inspectionScore: values.inspectionScore,
      inspectionDate: fDate(values.inspectionDate, 'yyyy-MM-dd'),
      inspectionResult: values.inspectionResult,
      inspectionNote: values.inspectionNote,
    };
    postInspection({ data: payload });
  });

  return (
    <Stack spacing={5}>
      <Stack spacing={0.5} my={5}>
        <InspectionTitle>{facility?.title || '-'}</InspectionTitle>
        <ListSubContentText textAlign="center">
          북구 {sliceSerialNumber(facility?.serialNumber) || '-'}
        </ListSubContentText>
      </Stack>
      <InspectionInputs
        form={form}
        date={form.watch('inspectionDate')}
        setDate={(date: any) => form.setValue('inspectionDate', date)}
      />
      <Stack direction="row" spacing={1} mt={5}>
        <PrimaryButton onClick={onSubmit}>제출하기</PrimaryButton>
        <PrimaryOutlinedButton
          sx={{ maxWidth: 156 }}
          onClick={() => {
            setMode('INFO');
          }}
        >
          취소
        </PrimaryOutlinedButton>
        <ApiResultModal
          apiResult={postInspectionResult}
          successTitle="등록됐습니다."
          successCode={201}
          onSuccessClose={() => {
            setMode('INFO');
            getInspections();
            getFacilities();
            getFacility();
          }}
          failTitle="관리자에게 문의해주세요."
          ErrorCodeTable={{
            PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          }}
        />
      </Stack>
    </Stack>
  );
}
